import React from 'react'
import { useParams } from 'react-router-dom'

const SignageDetails = () => {
    const {slug} = useParams();
  return (
    <div>{slug}</div>
  )
}

export default SignageDetails